import { defineMessages } from 'react-intl';

const messages = defineMessages({
  attributesTabHeader: {
    id: 'ItemDetails.AttributesTabHeader',
    defaultMessage: 'Attributes',
  },
  nutritionTabHeader: {
    id: 'ItemDetails.NutritionTabHeader',
    defaultMessage: 'Nutrition',
  },
  availabilityTabHeader: {
    id: 'ItemDetails.AvailabilityTabHeader',
    defaultMessage: 'Availability',
  },
  additionalDetailsTabHeader: {
    id: 'ItemDetails.AdditionalDetailsTabHeader',
    defaultMessage: 'Source Details',
  },
  tabAriaLabel: {
    id: 'ItemDetails.TabAriaLabel',
    defaultMessage: 'Detailed Item Information',
  },
  fieldLabel: {
    id: 'ItemDetails.fieldLabel',
    defaultMessage: 'Field',
  },
  sourceLabel: {
    id: 'ItemDetails.sourceLabel',
    defaultMessage: 'Source',
  },
  valueLabel: {
    id: 'ItemDetails.valueLabel',
    defaultMessage: 'Value',
  },
});

export default messages;
